import { RemoteLoadNewTicketSuggestion } from '@/javascript/data/usecases'
import { LoadNewTicketSuggestion } from '@/javascript/domain/usecases'
import {  makeApiUrl, makeAxiosHttpClient } from '../http'

export const makeRemoteLoadNewTicketSuggestion = (): LoadNewTicketSuggestion =>
  new RemoteLoadNewTicketSuggestion(makeApiUrl('/ai_assist/ticket_assist/new_suggestion'), makeAxiosHttpClient())